import { Link } from 'react-router-dom';
import { latestArticles } from '@/mocks/gossip';

const cardBgColors = [
  'bg-accent-100/70',
  'bg-secondary-100/70',
  'bg-background-200',
  'bg-primary-100/70',
  'bg-accent-50',
  'bg-secondary-50',
];

export default function LatestGrid() {
  return (
    <section id="latest" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8 md:mb-12">
          <div>
            <p className="text-xs font-semibold text-accent-600 uppercase tracking-widest mb-2 font-heading">
              Breaking News
            </p>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-900 font-heading">
              最新猛料
              <span className="text-accent-500 font-heading italic ml-2 text-xl md:text-3xl">实时追踪</span>
            </h2>
          </div>
          <Link
            to="/category/star-collapse"
            className="hidden sm:flex items-center gap-1 text-sm font-medium text-foreground-600 hover:text-foreground-900 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article, idx) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group rounded-2xl overflow-hidden bg-background-50 hover:bg-background-50 transition-all duration-300 cursor-pointer"
            >
              <div className={`relative overflow-hidden ${cardBgColors[idx % cardBgColors.length]}`}>
                <div className="aspect-[16/10] relative">
                  <img
                    src={article.imageUrl}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  {article.hot && (
                    <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-semibold rounded-full flex items-center gap-1">
                      <i className="ri-fire-line text-[10px]"></i>
                      爆
                    </span>
                  )}
                </div>
              </div>

              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-[11px] font-medium text-accent-700 bg-accent-100 px-2 py-0.5 rounded-full">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-500">{article.date}</span>
                </div>

                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-700 transition-colors line-clamp-2 leading-snug mb-2">
                  {article.title}
                </h3>

                <p className="text-xs md:text-sm text-foreground-600 line-clamp-2 leading-relaxed mb-3">
                  {article.excerpt}
                </p>

                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views > 10000
                      ? `${(article.views / 10000).toFixed(1)}万`
                      : article.views}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.date}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/star-collapse"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors"
          >
            查看全部猛料
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}